import zzc from './zzc';


export default function setTitle(title = '旅行商城', options = {}) {
  options = { ...options, title };
  zzc.call('webviewtitle', options);
}
